import { useState, useEffect } from "react";
export var useUserInfo = function () {
    var _a = useState(null), userInfo = _a[0], setUserInfo = _a[1];
    var _b = useState(null), error = _b[0], setError = _b[1];
    useEffect(function () {
        try {
            var userInfoString = localStorage.getItem("userInfo");
            if (userInfoString) {
                var parsedUserInfo = JSON.parse(userInfoString);
                setUserInfo(parsedUserInfo);
            }
            else {
                setUserInfo(null);
            }
        }
        catch (err) {
            setError(err instanceof Error ? err : new Error("Failed to parse user info"));
        }
    }, []);
    // Helper function to update user info
    var updateUserInfo = function (newUserInfo) {
        try {
            localStorage.setItem("userInfo", JSON.stringify(newUserInfo));
            setUserInfo(newUserInfo);
        }
        catch (err) {
            setError(err instanceof Error ? err : new Error("Failed to update user info"));
        }
    };
    // Helper function to clear user info
    var clearUserInfo = function () {
        localStorage.removeItem("userInfo");
        setUserInfo(null);
    };
    return { userInfo: userInfo, error: error, updateUserInfo: updateUserInfo, clearUserInfo: clearUserInfo };
};
